import React from 'react';
import { FaSpinner } from 'react-icons/fa';

const Loading = ({ fullScreen = false, message = 'Chargement...' }) => {
  if (fullScreen) {
    return (
      <div className="fixed inset-0 bg-white bg-opacity-90 flex items-center justify-center z-50">
        <div className="text-center">
          <div className="animate-spin mb-4">
            <FaSpinner className="h-12 w-12 text-purple-600" />
          </div>
          <p className="text-gray-600">{message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-8">
      <div className="animate-spin mb-3">
        <FaSpinner className="h-8 w-8 text-purple-600" />
      </div>
      <p className="text-gray-600">{message}</p>
    </div>
  );
};

export default Loading;